import React, { Component, useState } from "react";
import { Container, Row, Button, Form, Modal } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { useSearchParams, Link } from "react-router-dom";
import { apiCall } from './../../helpers/api';
import { getStatusPill, getDeliveryStatus } from "../../helpers/status";
import { getDifference } from './../../helpers/dates'
import AlertModal from "../../components/alerts/alert";
import SupportModal from "../../components/support/support";
import { useImageContext } from "../../hooks/useImageContext";
import { formatText } from "../../helpers/format";
import { getCurrencySymbol } from "../../helpers/currency";
import { validateImage, getImageUrl, compressImage, clientUploadMultipleImages } from "../../helpers/images";
import './MyBids.css';
import NoAccess from "../../images/no-access.png";
import FullPageSpinner from "../../components/spinner/FullPageSpinner";
import SmartImage from "../../components/images/SmartImage";
import Topbar from "../../components/topbar/Topbar";
import Footer from "../../components/footer/Footer";
import Cross from "../../images/cross.svg";
import instagram from './../../images/instagram.svg';
import tiktok from './../../images/tiktok.svg';
import youtube from './../../images/youtube.svg';
import facebook from './../../images/facebook.svg';
import twitter from './../../images/twitter.svg';

const socialIcons = {
  "instagram" : instagram,
  "tiktok" : tiktok,
  "youtube" : youtube,
  "facebook" : facebook,
  "twitter" : twitter,
}

class ImageUploadPreviewComponent extends Component {
 
  constructor(props) {
    super(props)
    this.state = {
      files: this.props.images,
      errors: [],
      draggedFile: null,
      uploading: false
    }
    this.previewFiles = this.previewFiles.bind(this)
    this.imageFileTypes = ["image/png","image/jpeg","image/jpg","image/webp","image/heic"]
  }

  async previewFiles(e) {
    this.setState({uploading: true})
    var errors = [];
    var files = e.target.files;
    var fileArray = this.state.files;
      if (files.length + fileArray.length){
          files = Object.entries(files).slice(0,5-fileArray.length).map(file => file[1]);
    }
    for (var file of files) {
      var [validationResult, validationReason] = validateImage(file)
        if (validationResult){
            file = await compressImage(file,0.95)
            var tempFile = {"url":URL.createObjectURL(file),"data":file,"metadata":null,"type":this.imageFileTypes.includes(file.type) ? "image" : "video","new":true}
            var response = await apiCall(`getUploadSignature?folder=ugc&asset_type=${tempFile.type}`,{ "method" : "GET" });
        if (response["success"]) {
          tempFile.metadata = response["success"]["metadata"]
          fileArray.push(tempFile);
        }
        else {
          errors.push(`${file.name} could not be uploaded: ${response["failure"]["error"]}`)
        }
      }
      else {
        errors.push(`${file.name} could not be uploaded: ${validationReason}`)
      }
    }
    this.setState({ files: fileArray, errors: errors, uploading: false })
    this.props.setImages(fileArray)
    this.props.setImagesChanged(true)
  }

  removeFile(targetFile){
      var fileArray = this.state.files.filter(function(file) {return file.url != targetFile.url });
    this.setState({ files: fileArray })
    this.props.setImages(fileArray)
    this.props.setImagesChanged(true)
  }

  render() {
    return (
      <>
        <div className="form-group multi-preview mt-3">
          {this.state.files.length > 0 && (this.state.files.map((file, index) => (
            <span key={file.url || index} className="imageWrapper mb-3">
              {(() => {
                const isImage = file.data ? this.imageFileTypes.includes(file.data.type) : file.type === "image";
                return isImage ?
                  <>
                    <img id={file.url} height="120px" width="120px" className="me-3 object-fit-cover rounded border" src={file.url} alt="..." />
                    <img className="overlayTopRight" title="Remove this image" onClick={e => this.removeFile(file)} src={Cross} />
                  </>
                  :
                  <>
                    <video id={file.url} loop height="120px" autoPlay width="120px" className="me-3 object-fit-cover rounded border" src={file.url} alt="..." />
                    <img className="overlayTopRight" title="Remove this image" onClick={e => this.removeFile(file)} src={Cross} />
                  </>
              })()}
            </span>
          )))}
          {this.state.errors && (<>{this.state.errors.map((error, idx) => (<p key={idx}>{error}</p>))}</>)}
        </div>
        <Form.Group className="multiUpload">
          {this.state.uploading ? (
            <div className="multiUploadBox"><span className="spinner-border text-primary" role="status" aria-hidden="true"></span></div>
          ) : (
            <button
              type="button"
              className="multiUploadBox"
              onClick={() => this.fileInput && this.fileInput.click()}
              style={{ cursor: 'pointer' }}
            >
              Drag & Drop or <span className="text-primary">Upload</span>
            </button>
          )}
          <Form.Control
            ref={ref => this.fileInput = ref}
            disabled={this.state.files.length >= 5 || this.state.uploading}
            type="file"
            onChange={this.previewFiles}
            multiple
            accept=".png, .jpg, .jpeg, .webp, .heic, .mp4, .webm"
            style={{ display: 'none' }}
          />
          {this.state.files.length >= 5 && (
            <div className="text-danger mt-3 small">
              If you'd like to change any photos, please delete one first
            </div>
          )}
        </Form.Group>
      </>
    )
  }
}

class MyBidView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      bid: null,
      otherCampaigns: [],
      newImages: [],
      newLinks: "",
      deletedContributions: []
    };

    // Per-contribution update staging (NOT in React state)
    this.updateFilesByContribution = {}; // { [contribId]: [tempFile] }
    this.fileInputRefs = {};             // { [contribId]: HTMLInputElement }

    this.getMyBid(props.bidID)
    this.CompleteModal = this.CompleteModal.bind(this);
    this.CancelModal = this.CancelModal.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  async getLatestCampaigns() {
    var response = await apiCall("campaigns?limit=5&active=true&live=true", { "method": "GET" });
    if (response["success"]) {
      this.setState({
        otherCampaigns: response["success"]["campaigns"] || [],
      });
    }
    else {
      this.setState({
        error: response["failure"]["error"]
      });
    }
    this.setState({
      isLoaded: true
    });
  }

  async getMyBid(bidID) {
    var response = await apiCall(`influencer/myBid?id=${bidID}`, { "method": "GET" });
    if (response["success"]) {
      this.setState({
        bid: response["success"]["bid"]
      });
      this.getLatestCampaigns()
    }
    else {
      this.setState({
        error: response["failure"]["error"]
      });
      this.setState({ isLoaded: true });
    }
  }

  async markAsReceived(bidID, campaignID) {
    var response = await apiCall(`campaign/bid/markAsReceived?id=${campaignID}`, { "method": "PUT", "data": { "bidID": bidID } });
    if (response["success"]) {
      this.getMyBid(bidID)
    }
    else {
      this.props.setAlert({ "display": "toast", "visible": true, "title": "Error Confirming Delivery", "content": response["failure"]["error"], "className": "bg-danger text-white" })
    }
  }


CompleteModal(props) {
  const contentReviewEnabled = props.bid.campaignDetail.contentReviewEnabled;
  // Local, non-React state for submit spinner + error
  if (!this.completeModalState) {
    this.completeModalState = { isSubmitting: false, error: null };
  }
  const setCompleteModalState = updates => {
    this.completeModalState = { ...this.completeModalState, ...updates };
    this.forceUpdate();
  };

  // NEW: State for selected contribution to view in detail modal
  if (!this.selectedContribution) {
    this.selectedContribution = null;
  }

  const imageFileTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp", "image/heic"];

  const contentRequired =
    props.bid.campaignDetail.campaignType === "sampling" ||
    props.bid.campaignDetail.campaignType === "content" ||
    (props.bid.campaignDetail.campaignType === "gifting" && props.bid.campaignDetail.contentReviewEnabled) ||
    (!getDifference(props.bid.bidDetail.dueDate).future && props.bid.bidDetail.state === "Accepted");

  const { newImages, newLinks } = this.state;

  // Cleanup staged files and refs on any modal close
  const handleClose = e => {
    this.updateFilesByContribution = {};
    this.fileInputRefs = {};
    if (props.handleClose) props.handleClose(e);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCompleteModalState({ isSubmitting: true, error: null });

    let response = null;

    // --- Custom logic for gifting/ready_for_completion ---
    const campaignType = props.bid.campaignDetail.campaignType;
    const bidState = props.bid.bidDetail.state;
    // Allow completion without upload if gifting and Ready for Completion
    if (campaignType === "gifting" && bidState === "Ready for Completion") {
      response = await apiCall(`campaign/bid/complete?id=${props.id}`, { method: "PUT", data: { bidID: props.bid.bidDetail.id } });
    } else {
      // Build updates[] from staged per-contribution replacement files
      let updates = [];
      for (const [id, files] of Object.entries(this.updateFilesByContribution || {})) {
        if (files && files.length > 0) {
          const file = files[0];
          // Handle links differently - they don't need upload
          if (file.type === "link") {
            updates.push({
              id,
              asset: {
                type: "link",
                url: file.url || file.id,
                id: file.url || file.id
              }
            });
          } else {
            // Handle image/video uploads
            const uploaded = await clientUploadMultipleImages(files, props.class.props.setAlert);
            if (uploaded && uploaded.length > 0) {
              updates.push({ id, asset: uploaded[0] });
            }
          }
        }
      }

      // Upload new content (bottom uploader)
      let uploadedNew = [];
      if (newImages && newImages.length > 0) {
        uploadedNew = await clientUploadMultipleImages(newImages, props.class.props.setAlert);
      }

      // Only call API if something changed (or if not required and user is just completing)
      const deletedContributions = this.state.deletedContributions || [];
      if (updates.length > 0 || uploadedNew.length > 0 || (newLinks && newLinks.trim()) || deletedContributions.length > 0) {
        response = await apiCall(`campaign/bid/complete?id=${props.id}`, {
          method: "PUT",
          data: {
            bidID: props.bid.bidDetail.id,
            updates,
            images: uploadedNew,
            links: newLinks,
            deleteContributionIds: deletedContributions
          }
        });

        if (response?.success) {
          this.updateFilesByContribution = {};
          this.fileInputRefs = {};
          this.setState({ newImages: [], newLinks: "", deletedContributions: [] });
        }
      } else if (!contentRequired) {
        response = await apiCall(`campaign/bid/complete?id=${props.id}`, { method: "PUT", data: { bidID: props.bid.bidDetail.id } });
      } else {
        response = null;
      }
    }

    if (response && response["success"]) {
      props.class.getMyBid(props.bid.bidDetail.id)
      handleClose();
      props.class.props.setAlert({ "display": "toast", "visible": true, "title": "Bid Completed", "content": "Bid Successfully Completed", "className": "bg-success text-white" })
      setCompleteModalState({ isSubmitting: false, error: null });
    } else if (response && response["failure"]) {
      setCompleteModalState({ isSubmitting: false, error: response["failure"]["error"] });
      props.class.props.setAlert({ "display": "toast", "visible": true, "title": "Error Submitting Bid", "content": response["failure"]["error"], "className": "bg-danger text-white" })
    } else {
      setCompleteModalState({ isSubmitting: false, error: contentRequired ? "No changes to submit" : null });
      if (contentRequired) {
        props.class.props.setAlert({ "display": "toast", "visible": true, "title": "No changes", "content": "Please add required content before completing.", "className": "bg-danger text-white" })
      }
    }
  };

  return (
    <>
      <Modal size="lg" centered show={props.show && !this.selectedContribution} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Complete Collaboration?</Modal.Title>
        </Modal.Header>
        <Form>
          <Modal.Body className="completeCollaboration">
            {props.bid.bidDetail.meta?.rejectReason && (
              <div className="alert alert-warning">
                <strong>Previous submission rejected.</strong><br />The following reason was given:<br /><i>{props.bid.bidDetail.meta.rejectReason}</i> <br />
              </div>
            )}
            {props.bid.bidDetail.contributions && props.bid.bidDetail.contributions.some(c => c.platform === "self" && !(this.state.deletedContributions || []).includes(c.id)) && (
            <>
              <div className="mb-4">
                <h6 className="mb-3">All Submitted Content</h6>
                
                {/* MINIMAL GRID VIEW */}
                <div className="row g-3">
                  {props.bid.bidDetail.contributions &&
                    props.bid.bidDetail.contributions
                      .filter(contribution => !(this.state.deletedContributions || []).includes(contribution.id))
                      .map((contribution) => {
                        const contribId = contribution.id;
                        const currentVersion = contribution.assetUrl;
                        const historyVersions = Array.isArray(contribution.versions) ? contribution.versions : [];
                        const allVersions = [...historyVersions, currentVersion].filter(Boolean);

                        // Check if there's a staged replacement for this contribution
                        const stagedReplacement = this.updateFilesByContribution?.[contribId]?.[0];

                        // Status badge - UPDATED LOGIC
                        let statusBadge = 'secondary';
                        let statusText = 'Pending';
                        
                        // If there's a staged replacement, show "Ready to Submit"
                        if (stagedReplacement) {
                          statusBadge = 'warning';
                          statusText = 'Ready to Submit';
                        } else if (currentVersion?.meta?.reviewed) {
                          statusBadge = currentVersion.meta.approved ? 'success' : 'danger';
                          statusText = currentVersion.meta.approved ? 'Approved' : 'Rejected';
                        }

                        const isRejected = !!(currentVersion?.meta?.reviewed && !currentVersion?.meta?.approved);
                        const hasComments = allVersions.some(ver => ver?.meta?.reviewNotes);

                        // Show the staged replacement preview if available, otherwise show current
                        const displayVersion = stagedReplacement || currentVersion;
                        const displayType = stagedReplacement ? stagedReplacement.type : contribution.assetType;

                        return (
                          <div key={contribId} className="col-6 col-md-4 col-lg-3">
                            <button
                              type="button"
                              className="card h-100 border-0 shadow-sm contribution-card-hover text-start"
                              style={{ cursor: 'pointer', background: 'none', padding: 0, border: 'none' }}
                              onClick={() => {
                                this.selectedContribution = contribution;
                                this.setState(prevState => ({
                                  _selectedContributionVersion: (prevState && prevState._selectedContributionVersion ? prevState._selectedContributionVersion : 0) + 1,
                                }));
                              }}
                            >
                              {/* Preview */}
                              <div className="position-relative" style={{ height: 160, overflow: 'hidden', background: '#f8f9fa' }}>
                                {displayType === "image" && displayVersion && (
                                  <img 
                                    src={stagedReplacement ? stagedReplacement.url : getImageUrl(props.class.props.providers, displayVersion)} 
                                    alt="" 
                                    className="w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                  />
                                )}
                                {displayType === "video" && displayVersion && (
                                  <video 
                                    src={stagedReplacement ? stagedReplacement.url : getImageUrl(props.class.props.providers, displayVersion, null, false, true)} 
                                    className="w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                  />
                                )}
                                {displayType === "link" && displayVersion && (
                                  <div className="link-card d-flex align-items-center justify-content-center w-100 h-100" style={{height:'100%'}}>
                                    <svg width="100%" height="100%" fill="currentColor" className="text-primary" viewBox="0 0 16 16" style={{objectFit:'cover', width:'100%', height:'100%'}}>
                                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                    </svg>
                                  </div>
                                )}
                                
                                {/* Status Badge - Top Right */}
                                {contentReviewEnabled && (
                                <span 
                                  className={`badge bg-${statusBadge} position-absolute top-0 end-0 m-2`}
                                  style={{ fontSize: '0.7rem' }}
                                >
                                  {statusText}
                                </span>
                                  )}
                                {/* Indicators - Top Left */}
                                <div className="position-absolute top-0 start-0 m-2 d-flex gap-1">
                                  {allVersions.length > 1 && (
                                    <span className="badge bg-dark bg-opacity-75" style={{ fontSize: '0.65rem' }} title="Has version history">
                                      <svg width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                      </svg>
                                      <span className="ms-1">{allVersions.length}</span>
                                    </span>
                                  )}
                                  {hasComments && (
                                    <span className="badge bg-info bg-opacity-75" style={{ fontSize: '0.65rem' }} title="Has comments">
                                      <svg width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .710-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894z"/>
                                      </svg>
                                    </span>
                                  )}
                                  {/* NEW: Staged replacement indicator */}
                                  {stagedReplacement && (
                                    <span className="badge bg-success bg-opacity-75" style={{ fontSize: '0.65rem' }} title="Replacement ready">
                                      <svg width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                      </svg>
                                    </span>
                                  )}
                                </div>

                                {/* Rejected indicator - Bottom - ONLY SHOW IF NOT REPLACED */}
                                {isRejected && !stagedReplacement && contentReviewEnabled && (
                                  <div className="position-absolute bottom-0 start-0 end-0 bg-danger text-white text-center py-1" style={{ fontSize: '0.7rem' }}>
                                    <svg width="10" height="10" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                    </svg>
                                    Needs replacement
                                  </div>
                                )}

                                {/* NEW: Ready to submit indicator - Bottom */}
                                {stagedReplacement && (
                                  <div className="position-absolute bottom-0 start-0 end-0 bg-success text-white text-center py-1" style={{ fontSize: '0.7rem' }}>
                                    <svg width="10" height="10" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                    Click Complete to submit
                                  </div>
                                )}
                              </div>
                            </button>
                          </div>
                        );
                      })}
                </div>
              </div>
              <hr className="my-4" />
            </>
            )}

            {/* New content section */}
            {contentRequired ? (
              <>
                <h6 className="mb-3">Add New Content</h6>
                <p className="text-muted small mb-3">Please add any new content you've created for this campaign below.</p>
                <div className="mb-3">
                  <label className="form-label small fw-bold">What we're looking for</label>
                  <div className="small text-muted">{formatText(props.bid.campaignDetail.lookingFor)}</div>
                </div>
                {props.bid.campaignDetail.campaignType === "gifting" && props.bid.campaignDetail.trackingTags && props.bid.campaignDetail.trackingTags.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label small fw-bold">Required Tracking Tags:</label>
                    <div className="d-flex flex-wrap gap-2">
                      {props.bid.campaignDetail.trackingTags.map(tag => (
                        <span key={tag.tag} className="badge bg-primary">
                          {tag.tag}
                          {tag.socials.length > 0 && (
                            <span className="ms-1">
                              ({tag.socials.map(social => (
                                <img key={social} width="14px" height="14px" src={socialIcons[social]} className="ms-1" alt={social} />
                              ))})
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <ImageUploadPreviewComponent
                  images={newImages}
                  setImages={(imgs) => this.setState({ newImages: imgs })}
                  setImagesChanged={() => { }}
                />
                <Form.Group className="mt-3">
                  <Form.Label className="small">Or add links to 3rd party platforms</Form.Label>
                  <Form.Control
                    value={newLinks}
                    onChange={e => this.setState({ newLinks: e.target.value })}
                    as="textarea"
                    placeholder="Enter links one per row"
                    rows={3}
                  />
                </Form.Group>
                <p className="text-muted small mt-3">
                  Marking this collaboration as complete will notify {props.bid.campaignDetail.brand.name}, who will then review and confirm you have completed the required tasks.
                </p>
                <hr className="my-4" />
              </>
            ) : (
              <>
                <div className="alert alert-info mb-3">
                  <strong>Before completing:</strong> Ensure all required content is posted with correct tracking tags
                </div>
                {props.bid.campaignDetail.campaignType === "gifting" && props.bid.campaignDetail.trackingTags && props.bid.campaignDetail.trackingTags.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label small fw-bold">Required Tracking Tags:</label>
                    <div className="d-flex flex-wrap gap-2">
                      {props.bid.campaignDetail.trackingTags.map(tag => (
                        <span key={tag.tag} className="badge bg-primary">
                          {tag.tag}
                          {tag.socials.length > 0 && (
                            <span className="ms-1">
                              ({tag.socials.map(social => (
                                <img key={social} width="14px" height="14px" src={socialIcons[social]} className="ms-1" alt={social} />
                              ))})
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <div className="mb-3">
                  <label className="form-label small fw-bold">What we're looking for</label>
                  <div className="small text-muted">{formatText(props.bid.campaignDetail.lookingFor)}</div>
                </div>
                <p className="text-muted small">
                  Marking this collaboration as complete will notify {props.bid.campaignDetail.brand.name}, who will then review and confirm you have completed the required tasks.
                </p>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={this.completeModalState.isSubmitting}
              type="submit"
              onClick={handleSubmit}
            >
              {this.completeModalState.isSubmitting
                ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Completing...</>
                : "Complete Collaboration"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* DETAILS MODAL - Shows when clicking a contribution */}
      {this.selectedContribution && this.ContributionDetailsModal({
        contribution: this.selectedContribution,
        providers: props.class.props.providers,
        onClose: () => {
          this.selectedContribution = null;
          this.forceUpdate();
        },
        setAlert: props.class.props.setAlert,
        stagedReplacement: this.updateFilesByContribution?.[this.selectedContribution.id]?.[0],
        onReplace: (contribId, file) => {
          this.updateFilesByContribution[contribId] = [file];
          this.forceUpdate();
        },
        contentReviewEnabled: props.bid.campaignDetail.contentReviewEnabled
      })}
    </>
  )
}

ContributionDetailsModal(config) {
  const { contribution, providers, onClose, setAlert, stagedReplacement, onReplace, contentReviewEnabled } = config;
  
  if (!this.detailsModalState) {
    this.detailsModalState = {};
  }

  const contribId = contribution.id;
  const showVersions = contentReviewEnabled && this.detailsModalState[`${contribId}_versions`] || false;
  const showComments = contentReviewEnabled && this.detailsModalState[`${contribId}_comments`] || false;
  
  // State for delete confirmation
  if (!this.detailsModalState[`${contribId}_deleteConfirm`]) {
    this.detailsModalState[`${contribId}_deleteConfirm`] = false;
  }
  if (!this.detailsModalState[`${contribId}_isDeleting`]) {
    this.detailsModalState[`${contribId}_isDeleting`] = false;
  }
  const showDeleteConfirm = this.detailsModalState[`${contribId}_deleteConfirm`];
  const isDeleting = this.detailsModalState[`${contribId}_isDeleting`];
  
  if (!this.detailsModalState[`${contribId}_linkInput`]) {
    this.detailsModalState[`${contribId}_linkInput`] = '';
  }
  const linkInput = this.detailsModalState[`${contribId}_linkInput`] || '';
  
  const currentVersion = contribution.assetUrl;
  const historyVersions = Array.isArray(contribution.versions) ? contribution.versions : [];
  const allVersions = [...historyVersions, currentVersion].filter(Boolean);

  const imageFileTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp", "image/heic"];

  // Status
  let statusBadge = 'secondary';
  let statusText = 'Pending Review';
  if (currentVersion?.meta?.reviewed) {
    statusBadge = currentVersion.meta.approved ? 'success' : 'danger';
    statusText = currentVersion.meta.approved ? 'Approved' : 'Rejected';
  }

  const isRejected = !!(currentVersion?.meta?.reviewed && !currentVersion?.meta?.approved);
  const hasComments = allVersions.some(ver => ver?.meta?.reviewNotes);
  const isLink = contribution.assetType === "link";

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const [ok, reason] = validateImage(file);
    if (!ok) {
      setAlert({
        display: "toast",
        visible: true,
        title: "Invalid file",
        content: reason,
        className: "bg-danger text-white"
      });
      return;
    }

    let processed = file;
    if (imageFileTypes.includes(file.type)) {
      processed = await compressImage(file, 0.95);
    }

    const tempFile = {
      url: URL.createObjectURL(processed),
      data: processed,
      metadata: null,
      type: imageFileTypes.includes(processed.type) ? "image" : "video",
      new: true
    };

    const sig = await apiCall(`getUploadSignature?folder=ugc&asset_type=${tempFile.type}`, { method: "GET" });
    if (!sig.success) {
      setAlert({
        display: "toast",
        visible: true,
        title: "Upload error",
        content: sig.failure?.error || "Could not get upload signature",
        className: "bg-danger text-white"
      });
      return;
    }

    tempFile.metadata = sig.success.metadata;
    onReplace(contribId, tempFile);
    onClose();
  };

  const handleLinkSubmit = () => {
    const trimmedLink = linkInput.trim();
    
    if (!trimmedLink) {
      setAlert({
        display: "toast",
        visible: true,
        title: "Invalid link",
        content: "Please enter a valid URL",
        className: "bg-danger text-white"
      });
      return;
    }

    // Basic URL validation
    try {
      new URL(trimmedLink);
    } catch (e) {
      setAlert({
        display: "toast",
        visible: true,
        title: "Invalid link",
        content: "Please enter a valid URL (must start with http:// or https://)",
        className: "bg-danger text-white"
      });
      return;
    }

    // Create a "tempFile" object for link (similar structure for consistency)
    const linkReplacement = {
      url: trimmedLink,
      id: trimmedLink,
      type: "link",
      new: true
    };

    onReplace(contribId, linkReplacement);
    this.detailsModalState[`${contribId}_linkInput`] = '';
    onClose();
  };

  const handleDelete = async () => {
    // Instead of immediate API call, batch deletions in state
    this.setState(prevState => ({
      deletedContributions: [...(prevState.deletedContributions || []), contribId]
    }), () => {
      setAlert({
        display: "toast",
        visible: true,
        title: "Marked for Deletion",
        content: "This contribution will be deleted when you complete the collaboration.",
        className: "bg-warning text-dark"
      });
      this.detailsModalState[`${contribId}_deleteConfirm`] = false;
      this.forceUpdate();
      onClose();
    });
  };

  return (
    <>
      <Modal size="lg" show={true} onHide={onClose} centered style={{ zIndex: 1060 }}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className={`badge bg-${statusBadge} ms-2`}>{statusText}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Current Version - Large Preview */}
          <div className="text-center mb-4">
            {contribution.assetType === "image" && currentVersion && (
              <img 
                src={getImageUrl(providers, currentVersion)} 
                alt="" 
                className="img-fluid rounded border"
                style={{ maxHeight: 400 }}
              />
            )}
            {contribution.assetType === "video" && currentVersion && (
              <video 
                src={getImageUrl(providers, currentVersion, null, false, true)} 
                controls 
                className="w-100 rounded border"
                style={{ maxHeight: 400 }}
              />
            )}
            {contribution.assetType === "link" && currentVersion && (
              <div className="p-4 bg-light rounded">
                <svg width="64" height="64" fill="currentColor" className="text-primary mb-3" viewBox="0 0 16 16">
                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                </svg>
                <div>
                  <a 
                    href={currentVersion.url || currentVersion.id || (typeof currentVersion === 'string' ? currentVersion : '')} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Open Link
                  </a>
                </div>
                <div className="small text-muted mt-2" style={{ wordBreak: 'break-all' }}>
                  {currentVersion.url || currentVersion.id || (typeof currentVersion === 'string' ? currentVersion : 'Link')}
                </div>
              </div>
            )}
          </div>

          {/* Review Notes for Current Version */}
          {currentVersion?.meta?.reviewNotes && (
            <div className="alert alert-info">
              <strong>Latest Feedback:</strong>
              <div>{currentVersion.meta.reviewNotes}</div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="d-flex gap-2 mb-4">
            {showVersions && allVersions.length > 1 && (
              <button
                type="button"
                className="btn btn-outline-secondary flex-fill"
                onClick={() => {
                  this.detailsModalState[`${contribId}_versions`] = !showVersions;
                  this.forceUpdate();
                }}
              >
                <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                  <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                </svg>
                {showVersions ? 'Hide' : 'Show'} History ({allVersions.length})
              </button>
            )}

            {hasComments && (
              <button
                type="button"
                className="btn btn-outline-info flex-fill"
                onClick={() => {
                  this.detailsModalState[`${contribId}_comments`] = !showComments;
                  this.forceUpdate();
                }}
              >
                <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                  <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894z"/>
                </svg>
                {showComments ? 'Hide' : 'Show'} All Comments
              </button>
            )}
          </div>

          {/* Version History */}
          {showVersions && allVersions.length > 0 && (
            <div className="mb-4">
              <h6 className="mb-3">Version History</h6>
              <div className="row g-3">
                {allVersions.map((ver, idx) => (
                  <div key={ver.id || idx} className="col-4 col-md-3">
                    <div className="border rounded p-2">
                      {ver.type === "image" && (
                        <img 
                          src={getImageUrl(providers, ver)} 
                          alt="" 
                          className="img-fluid rounded mb-2"
                        />
                      )}
                      {ver.type === "video" && (
                        <video 
                          src={getImageUrl(providers, ver, null, false, true)} 
                          className="w-100 rounded mb-2"
                        />
                      )}
                      {ver.type === "link" && (
                        <div className="text-center p-3 bg-light rounded mb-2">
                          <svg width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                          </svg>
                          <div className="small text-muted text-truncate mt-1" style={{ fontSize: '0.65rem' }}>
                            {ver.url || ver.id || 'Link'}
                          </div>
                        </div>
                      )}
                      <div className="small text-center">
                        <div className="text-muted">v{idx + 1}</div>
                        {ver.meta?.reviewed && (
                          <span className={`badge ${ver.meta.approved ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '0.7rem' }}>
                            {ver.meta.approved ? '✓ Approved' : '✗ Rejected'}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* All Comments */}
          {showComments && (
            <div className="mb-4">
              <h6 className="mb-3">All Feedback</h6>
              {allVersions.map((ver, idx) => ver?.meta?.reviewNotes && (
                <div key={ver.id || idx} className="alert alert-secondary mb-2">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <strong className="small">Version {idx + 1}</strong>
                    <span className={`badge ${ver.meta.approved ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '0.7rem' }}>
                      {ver.meta.approved ? 'Approved' : 'Rejected'}
                    </span>
                  </div>
                  <div className="small">{ver.meta.reviewNotes}</div>
                </div>
              ))}
            </div>
          )}

          {/* Replace Section */}
          {isRejected && (
            <div className="border border-danger rounded p-3 bg-light mb-3">
              <h6 className="text-danger mb-2">
                <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                </svg>
                This submission was rejected
              </h6>
              
              {stagedReplacement ? (
                <div>
                  <div className="alert alert-success mb-2">
                    <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                    </svg>
                    Replacement ready! Click "Complete Collaboration" to submit.
                  </div>
                  <div className="text-center">
                    {stagedReplacement.type === "image" && (
                      <img src={stagedReplacement.url} className="img-fluid rounded border border-success" alt="" style={{ maxHeight: 200 }} />
                    )}
                    {stagedReplacement.type === "video" && (
                      <video src={stagedReplacement.url} controls className="w-100 rounded border border-success" style={{ maxHeight: 200 }} />
                    )}
                    {stagedReplacement.type === "link" && (
                      <div className="p-3 bg-light rounded border border-success">
                        <svg width="48" height="48" fill="currentColor" className="text-success mb-2" viewBox="0 0 16 16">
                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                        </svg>
                        <div className="small fw-bold mb-2">New Link:</div>
                        <div className="small text-break">{stagedReplacement.url || stagedReplacement.id}</div>
                      </div>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm mt-2 w-100"
                    onClick={() => {
                      if (isLink) {
                        this.detailsModalState[`${contribId}_linkInput`] = '';
                        this.forceUpdate();
                      } else {
                        if (!this.fileInputRefs[contribId]) {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = '.png,.jpg,.jpeg,.webp,.heic,.mp4,.webm';
                          input.onchange = handleFileSelect;
                          this.fileInputRefs[contribId] = input;
                        }
                        this.fileInputRefs[contribId].click();
                      }
                    }}
                  >
                    Choose Different {isLink ? 'Link' : 'File'}
                  </button>
                </div>
              ) : (
                <div>
                  {isLink ? (
                    // Link input section
                    <div>
                      <p className="small mb-3">Enter a new URL to replace the rejected link:</p>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="url"
                          placeholder="https://example.com/your-content"
                          value={linkInput}
                          onChange={(e) => {
                            this.detailsModalState[`${contribId}_linkInput`] = e.target.value;
                            this.forceUpdate();
                          }}
                        />
                        <Form.Text className="text-muted">
                          Must be a valid URL starting with http:// or https://
                        </Form.Text>
                      </Form.Group>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleLinkSubmit}
                        disabled={!linkInput.trim()}
                      >
                        <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                        </svg>
                        Submit Replacement Link
                      </button>
                    </div>
                  ) : (
                    // File upload section
                    <button
                      type="button"
                      className="btn btn-danger w-100"
                      onClick={() => {
                        if (!this.fileInputRefs[contribId]) {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = '.png,.jpg,.jpeg,.webp,.heic,.mp4,.webm';
                          input.onchange = handleFileSelect;
                          this.fileInputRefs[contribId] = input;
                        }
                        this.fileInputRefs[contribId].click();
                      }}
                    >
                      <svg width="16" height="16" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                      </svg>
                      Upload Replacement
                    </button>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Delete Button */}
          {!currentVersion?.meta?.approved && (
            <div className="border-top pt-3">
              <button
                type="button"
                className="btn btn-outline-danger w-100"
                onClick={() => {
                  this.detailsModalState[`${contribId}_deleteConfirm`] = true;
                  this.forceUpdate();
                }}
              >
                <svg width="16" height="16" fill="currentColor" className="me-2" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
                Delete This Contribution
              </button>
              <p className="text-muted small text-center mt-2 mb-0">
                This will permanently remove this submission
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 2000, background: 'rgba(0,0,0,0.4)' }}>
          <Modal
            show={true}
            onHide={() => {
              this.detailsModalState[`${contribId}_deleteConfirm`] = false;
              this.forceUpdate();
            }}
            centered
            style={{ zIndex: 2100 }}
          >
            <Modal.Header closeButton className="bg-danger text-white">
              <Modal.Title className="h6">Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex align-items-start mb-3">
                <svg width="48" height="48" fill="currentColor" className="text-danger me-3 flex-shrink-0" viewBox="0 0 16 16">
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>
                <div>
                  <h6 className="mb-2">Are you sure you want to delete this contribution?</h6>
                  <p className="text-muted small mb-0">
                    This action cannot be undone. The {contribution.assetType} will be permanently removed from your submission.
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  this.detailsModalState[`${contribId}_deleteConfirm`] = false;
                  this.forceUpdate();
                }}
                disabled={isDeleting}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={handleDelete}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Deleting...
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" fill="currentColor" className="me-2" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                      <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                    </svg>
                    Yes, Delete Contribution
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
}

  CancelModal(props) {
  var isSubmitting = false;
  var error = null;
  const handleSubmit = async e => {
    e.preventDefault();
    isSubmitting = true;
    var response = await apiCall(`campaign/cancelBid?id=${props.id}`, {
      "method": "PUT",
      "data": { "reason": props.class.props.cancellationReason }
    });
    if (response["success"]) {
      props.class.getMyBid(props.bid.bidDetail.id);
      props.handleClose();
      props.class.props.setAlert({
        "display": "toast",
        "visible": true,
        "title": "Bid Cancelled",
        "content": "Bid Successfully Cancelled",
        "className": "bg-success text-white"
      });
    } else {
      error = response["failure"]["error"];
      props.handleClose();
      props.class.props.setAlert({
        "display": "toast",
        "visible": true,
        "title": "Error Cancelling Bid",
        "content": error,
        "className": "bg-danger text-white"
      });
    }
    isSubmitting = false;
  };

  return (
    <Modal show={props.show} centered onHide={props.handleClose}>
      <Modal.Header className="bg-danger text-white" closeButton>
        <Modal.Title className="h6">Cancellation Confirmation</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body className="pb-0">
          <p>Are you sure you want to cancel this bid? You won't be able to undo this action once you've clicked yes.</p>
          {error && <div className="error text-danger small mb-3">{error}</div>}
          <Form.Label>Please confirm your reason for cancelling your bid.</Form.Label>
          <Form.Control
            onChange={e => props.class.props.setCancellationReason(e.target.value)}
            as="textarea"
            id="message"
            placeholder="Write your message here..."
            rows={5}
          />
        </Modal.Body>
        <br />
        <Modal.Footer className="p-3 pt-0 border-0 d-flex align-items-center justify-content-between">
          <Button variant="success" className="m-0" onClick={props.handleClose}>No, don't cancel my bid</Button>
          <Button
            variant="danger"
            className="m-0"
            disabled={isSubmitting || props.class.props.cancellationReason.length === 0}
            type="submit"
            onClick={handleSubmit}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cancelling...
              </>
            ) : "Yes, cancel my bid"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

  CampaignItem(campaign) {
    return (
      <Card className="shadow h-100">
        <Link className="position-relative d-block p-3" to={"/Campaign?id=" + campaign.id} reloadDocument>
          <SmartImage className="cardImage" wrapperClassName="smartImageWrapFill" src={getImageUrl(campaign.class.props.providers, campaign.images[0], ["w_150", "c_scale"])} alt={campaign.offering} />
        </Link>
        <Card.Body className="pt-0">
          <div className="text-center px-3 mb-2">
            <SmartImage src={getImageUrl(campaign.class.props.providers, campaign.brandIcon)} width="75%" height="50px" className="object-fit-contain" alt={campaign.brandName} />
          </div>
          <div className="text-center px-4">
            <Link className="wallInfo" to={"/Campaign?id=" + campaign.id} reloadDocument>
              {campaign.offering}
            </Link>
          </div>
        </Card.Body>
      </Card>
    )
  }

  render() {
    const { error, isLoaded, bid, otherCampaigns } = this.state;
    const handleCancelClose = () => this.props.setShowCancel(false);
    const handleCancelShow = () => { this.props.setCancellationReason(""); this.props.setShowCancel(true) };
    const handleCompleteClose = () => this.props.setShowComplete(false);
    const handleCompleteShow = () => this.props.setShowComplete(true);

    if (error) {
      return (
        <div className="text-danger text-center h-100 d-flex align-items-center justify-content-start px-4 px-md-0 py-5 flex-column fs-5 bg-secondary">
          <img src={NoAccess} className="noAccessImg my-5 rounded-xl shadow" />
          <div>Error: {error}</div>
        </div>
      );
    } else if (!isLoaded || !bid) {
      return <FullPageSpinner />;
    } else {
      const dueDate = getDifference(bid.bidDetail.dueDate)
      return (
        <Container className="fullscreenWithTopBar px-0" fluid>
          <Container className="px-0">
            <div className="py-4 bg-white border-bottom d-block d-md-none">
              <div className="pt-0 py-4 px-4 mx-3 position-relative">
                <Link className="backArrow d-flex align-items-center" onClick={() => window.history.back()}>
                  <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.8134 0.685713C10.5881 0.442875 10.2819 0.319992 9.97492 0.320057C9.6965 0.320057 9.41738 0.421144 9.19723 0.625416L0.365555 8.82172C0.132373 9.03812 -0.000166049 9.34189 -0.000166076 9.66003C-0.000166104 9.97816 0.132373 10.2819 0.365555 10.4983L9.19722 18.6946C9.66003 19.1242 10.3838 19.0973 10.8135 18.6343C11.2432 18.1713 11.2162 17.4477 10.7532 17.0181L2.82476 9.66003L10.7531 2.30204C11.2161 1.87233 11.2431 1.14871 10.8134 0.685713Z" fill="#002651" />
                  </svg>
                  <div className="sectionTitle text-truncate ms-2">My Bids</div>
                </Link>
              </div>
            </div>

            <div className="py-4 d-none d-md-block">
              <div className="pt-0 py-4 px-4 mx-3 position-relative">
                <Link className="backArrow d-flex align-items-center" onClick={() => window.history.back()}>
                  <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.8134 0.685713C10.5881 0.442875 10.2819 0.319992 9.97492 0.320057C9.6965 0.320057 9.41738 0.421144 9.19723 0.625416L0.365555 8.82172C0.132373 9.03812 -0.000166049 9.34189 -0.000166076 9.66003C-0.000166104 9.97816 0.132373 10.2819 0.365555 10.4983L9.19722 18.6946C9.66003 19.1242 10.3838 19.0973 10.8135 18.6343C11.2432 18.1713 11.2162 17.4477 10.7532 17.0181L2.82476 9.66003L10.7531 2.30204C11.2161 1.87233 11.2431 1.14871 10.8134 0.685713Z" fill="#002651" />
                  </svg>
                  <div className="sectionTitle text-truncate ms-2">My Bids</div>
                </Link>
              </div>
            </div>

            {this.CancelModal({ handleClose: handleCancelClose, show: this.props.showCancel, id: bid.campaignDetail.id, class: this, bid })}
            {this.CompleteModal({ handleClose: handleCompleteClose, show: this.props.showComplete, id: bid.campaignDetail.id, class: this, bid })}

            {(bid.bidDetail.state === "In Progress" || bid.bidDetail.state === "Changes Requested") && (bid.bidDetail.contributions?.some(c => c.platform === "self" && c.assetUrl?.meta?.reviewed && !c.assetUrl?.meta?.approved) || bid.bidDetail.meta?.rejectReason ) && (
                <div className="px-md-3 mb-3">
                    <div className="d-flex align-items-center gap-2 px-3 py-3 rounded" style={{backgroundColor: "#fff8e1", border: "1px solid #f0c040", color: "#856404", fontSize: "0.95rem"}}>
                        <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16" style={{flexShrink: 0}}>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
                        </svg>
                        <span className="fw-600">You have pending items to review and resubmit</span>
                    </div>
                </div>
            )}
            <Row className="px-md-3">
              <div className="col-sm-12 col-md-12 col-lg-6">
                <div className="bg-white pt-3 rounded-xl shadow position-relative">
                  {bid.campaignDetail.hasBudget && bid.bidDetail.fee != null && !Number.isNaN(Number(bid.bidDetail.fee)) && (
                    <div className="position-absolute top-0 end-0 mt-3 me-3 text-end text-nowrap">
                      <div className="text-muted" style={{ fontSize: '11px' }}>My bid</div>
                      <div className="text-navy" style={{ fontSize: '16px', fontWeight: 500 }}>{getCurrencySymbol(bid.campaignDetail.budget?.currency)}{bid.bidDetail.fee}</div>
                    </div>
                  )}
                  <Row className="px-3 pb-3">
                    <div className="col-4 col-sm-3 col-md-6 col-lg-5">
                      <SmartImage className="w-100 rounded-xl card-img-top cardImage" wrapperClassName="smartImageWrapFill" src={getImageUrl(this.props.providers, bid.campaignDetail.image, ["w_300", "c_scale"])} alt={bid.campaignDetail.title} />
                    </div>
                    <div className="col-8 col-sm-9 col-md-6 col-lg-7">
                      <div className="mb-2 fw-500 d-flex align-items-center">
                        <SmartImage src={getImageUrl(this.props.providers, bid.campaignDetail.brand.profileImage, ["w_80", "h_80", "c_scale"])} width="24px" className="rounded border me-2" alt={bid.campaignDetail.brand.name} wrapperClassName="d-inline-block" />
                        <div className="text-muted small">{bid.campaignDetail.brand.name}</div>
                      </div>
                      <h6 className="mb-2 fw-700 animated-background">{bid.campaignDetail.title}</h6>

                      {(bid.bidDetail.state == "Pending" || bid.bidDetail.state == "Cancelled" || bid.bidDetail.state == "Declined") && (
                        <div className="text-muted small mb-2 fw-500">
                          Bid: {new Date(bid.bidDetail.time * 1000).toLocaleDateString('en-GB', { year: "numeric", month: "long", day: "numeric" })}
                        </div>
                      )}

                      {(bid.bidDetail.state == "Accepted" || bid.bidDetail.state == "In Progress" || bid.bidDetail.state == "Changes Requested" || bid.bidDetail.state == "Ready for Completion") && (
                        <>
                          {!dueDate.future ? (
                            <div className="text-muted small mb-2 fw-500">
                              <b style={{ color: "red" }}>
                                Last Date to Post by: {new Date(bid.bidDetail.dueDate * 1000).toLocaleDateString('en-GB', { year: "numeric", month: "long", day: "numeric" })}
                              </b>
                            </div>
                          ) : (
                            <div className="text-muted small mb-2 fw-500">
                              Last Date to Post by: {new Date(bid.bidDetail.dueDate * 1000).toLocaleDateString('en-GB', { year: "numeric", month: "long", day: "numeric" })}
                            </div>
                          )}
                        </>
                      )}

                      {bid.bidDetail.state == "Marked as Complete" && (
                        <div className="text-muted small mb-2 fw-500">
                          Marked as Complete: {new Date(bid.bidDetail.completionTime * 1000).toLocaleDateString('en-GB', { year: "numeric", month: "long", day: "numeric" })}
                        </div>
                      )}

                      {bid.bidDetail.state == "Completed" && (
                        <div className="text-muted small mb-2 fw-500">
                          Completed: {new Date(bid.bidDetail.completionTime * 1000).toLocaleDateString('en-GB', { year: "numeric", month: "long", day: "numeric" })}
                        </div>
                      )}

                      {getStatusPill(bid.bidDetail.state)}
                    </div>
                  </Row>

                  {!bid.campaignDetail.event && ["Accepted", "Marked as Complete", "In Progress", "Completed"].includes(bid.bidDetail.state) &&
                    (!bid.bidDetail.hasOwnProperty("deliveryState") ? getDeliveryStatus("unsent") : getDeliveryStatus(bid.bidDetail.deliveryState))}

                  <div className="d-flex align-items-center border-top justify-content-between w-100">
                    <div>
                      <Link to={"/Campaign?id=" + bid.campaignDetail.id} className="text-center d-block px-3 py-3 fw-500 text-blue">
                        View details page
                      </Link>
                    </div>
                    <div>
                      {["Accepted", "In Progress"].includes(bid.bidDetail.state) && !bid.campaignDetail.event && (!bid.bidDetail.hasOwnProperty("deliveryState") || bid.bidDetail.deliveryState != "received")
                        ? <button type="button" onClick={() => this.markAsReceived(bid.bidDetail.id, bid.campaignDetail.id)} className="link btn my-2 me-2 btn-outline-success">Mark as Received</button>
                        : null}
                      {["Pending", "Accepted", "In Progress"].includes(bid.bidDetail.state)
                        ? <button type="button" onClick={handleCancelShow} className="link btn my-2 me-2 btn-outline-danger">Cancel Bid</button>
                        : null}
                    </div>
                  </div>
                </div>

                {bid.bidDetail.customAnswers && bid.bidDetail.customAnswers.length > 0 && (
                  <div className="bg-white rounded-xl shadow p-3 mt-3 mb-3 mb-md-4">
                    <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-1">
                      <div className="fw-500">Your application answers</div>
                      <div className="small text-muted">{bid.bidDetail.customAnswers.length}</div>
                    </div>
                    {bid.bidDetail.customAnswers.map((customAnswer, index) => (
                      <div key={customAnswer.questionId || index} className={index < bid.bidDetail.customAnswers.length - 1 ? "py-3 border-bottom" : "pt-3"}>
                        <div className="d-flex align-items-start">
                          <div className="text-blue fw-500 small me-2">{index + 1}.</div>
                          <div className="small fw-500">{customAnswer.question}</div>
                        </div>
                        <div className="bg-light rounded px-3 py-2 mt-2 ms-3 small text-dark text-break">
                          {Array.isArray(customAnswer.answer) ? customAnswer.answer.join(", ") : customAnswer.answer === true ? "Yes" : customAnswer.answer === false ? "No" : String(customAnswer.answer)}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="col-sm-12 col-md-12 col-lg-6">
                <div className="p-3 p-md-0">

                  {(bid.bidDetail.state == "Accepted" || bid.bidDetail.state == "In Progress" || bid.bidDetail.state == "Changes Requested" || bid.bidDetail.state == "Ready for Completion") && dueDate.future && (
                    <>
                      <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <svg width="40" height="44" viewBox="0 0 28 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.6825 35.6004L9.89497 39.4303L9.06971 37.1638C8.91476 36.7374 8.51225 36.4734 8.08314 36.4734C7.96393 36.4734 7.84275 36.4941 7.72435 36.5365L5.45444 37.3619L8.97995 29.8081L7.97351 27.6516C7.91669 27.5293 7.88331 27.4035 7.84319 27.2788L2.47965 38.7704C2.30006 39.1551 2.37039 39.6101 2.65726 39.9225C2.94453 40.235 3.39153 40.3462 3.79008 40.1993L7.45626 38.867L8.78967 42.5278C8.9351 42.9268 9.3062 43.1987 9.73056 43.2182C9.74605 43.2186 9.76115 43.2186 9.77665 43.2186C10.1827 43.2186 10.5546 42.9835 10.7279 42.6131L12.8416 38.0834L11.6825 35.6004Z" fill="#2EC7DE" />
                              <path d="M17.7907 27.173L22.5451 37.3597L20.2759 36.5343C20.0145 36.4386 19.7252 36.4513 19.4733 36.5696C19.221 36.6867 19.0255 36.8995 18.9306 37.1616L18.1053 39.4285L12.2558 26.8961C11.7011 27.0565 11.0892 27.1875 10.4098 27.1875C10.2918 27.1875 10.1786 27.1693 10.0625 27.1609L17.2721 42.6112C17.4454 42.9816 17.8169 43.2166 18.2241 43.2166C18.2388 43.2166 18.2547 43.2166 18.2698 43.2162C18.6942 43.1967 19.0657 42.9248 19.2103 42.5258L20.5441 38.8647L24.2091 40.1974C24.608 40.3443 25.0554 40.2327 25.3419 39.9207C25.6292 39.6078 25.6991 39.1529 25.5195 38.7686L19.8611 26.6448C19.6366 26.7579 19.4002 26.8627 19.1435 26.9457C18.7144 27.0862 18.2583 27.1541 17.7906 27.1724L17.7907 27.173Z" fill="#2EC7DE" />
                              <path d="M17.4723 27.5595C16.7523 27.5595 16.0733 27.3157 15.4177 27.0803C14.9115 26.8989 14.389 26.7123 14 26.7123C13.6102 26.7123 13.0881 26.8989 12.5827 27.0807C11.9263 27.3165 11.2476 27.5599 10.5277 27.5599C10.2273 27.5599 9.94001 27.5162 9.67261 27.4297C8.6173 27.087 8.00781 26.1842 7.46942 25.3883C7.18016 24.9603 6.88057 24.5176 6.5933 24.3084C6.29888 24.094 5.77917 23.9436 5.27658 23.7983C4.35874 23.5327 3.31893 23.2321 2.67405 22.3464C2.03514 21.4687 2.06812 20.3923 2.09633 19.4432C2.11301 18.9156 2.1293 18.3697 2.01368 18.0147C1.90759 17.6892 1.58416 17.2755 1.27146 16.8753C0.675462 16.1131 0 15.2492 0 14.1237C0 12.9974 0.675462 12.1335 1.27146 11.3713C1.58416 10.9711 1.90838 10.557 2.01368 10.2319C2.1293 9.87618 2.11262 9.33109 2.09633 8.80344C2.06772 7.85421 2.03474 6.77709 2.67405 5.89979C3.31891 5.01408 4.35909 4.71353 5.27617 4.44797C5.77919 4.30266 6.29853 4.1522 6.59371 3.93782C6.88018 3.729 7.17977 3.28633 7.46903 2.85797C8.00742 2.06238 8.61732 1.15958 9.67222 0.81698C9.93923 0.730433 10.2269 0.686768 10.5265 0.686768C11.2472 0.686768 11.9267 0.930524 12.5827 1.16595C13.0881 1.34697 13.6109 1.53476 14 1.53476C14.3891 1.53476 14.9115 1.34697 15.4173 1.16595C16.0729 0.930128 16.7532 0.686768 17.4731 0.686768C17.7727 0.686768 18.0604 0.730438 18.327 0.81698C19.3831 1.15959 19.9926 2.06158 20.5302 2.85797C20.8202 3.28674 21.1198 3.72939 21.4067 3.93823C21.7011 4.15222 22.2208 4.30307 22.7234 4.44837C23.6405 4.71357 24.6819 5.0145 25.3256 5.9002C25.9653 6.77797 25.9323 7.8543 25.9033 8.80344C25.8866 9.33106 25.8703 9.87689 25.9859 10.2319C26.0924 10.557 26.4154 10.9711 26.7285 11.3713C27.3249 12.1335 28 12.9974 28 14.1237C28 15.25 27.3245 16.1139 26.7285 16.8761C26.4154 17.2763 26.0924 17.6904 25.9859 18.0155C25.8707 18.3709 25.887 18.9164 25.9033 19.444C25.9331 20.3932 25.9653 21.4704 25.3256 22.3477C24.6815 23.2334 23.6405 23.5343 22.7234 23.7995C22.22 23.9452 21.7003 24.096 21.4067 24.31C21.1194 24.5188 20.8199 24.9615 20.5302 25.3899C19.9926 26.1863 19.3819 27.0883 18.3262 27.4309C18.0604 27.5158 17.7719 27.5595 17.4723 27.5595L17.4723 27.5595Z" fill="#2EC7DE" />
                            </svg>
                          </div>
                          <div>
                            <div className="fw-500 mb-1">Start creating and tagging!</div>
                            <div className="text-muted small">Use the following tags in all content:</div>
                            <div className="small">{bid.campaignDetail.trackingTags.map(tag => (<> {tag.tag}<br /> </>))} </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <svg width="40" height="34" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18.7609 22.6451C18.7609 20.7215 20.3607 19.1613 22.3331 19.1613H26.8028C28.7749 19.1613 30.375 20.7233 30.375 22.6451C30.375 24.569 28.7752 26.129 26.8028 26.129H22.3331C20.3611 26.129 18.7609 24.5671 18.7609 22.6451ZM20.5477 22.6451C20.5477 23.6057 21.3485 24.3871 22.3332 24.3871H26.8029C27.7883 24.3871 28.5883 23.6072 28.5883 22.6451C28.5883 21.6848 27.7876 20.9032 26.8029 20.9032H22.3332C21.3477 20.9032 20.5477 21.6833 20.5477 22.6451ZM13.8475 25.2581C14.3409 25.2581 14.741 25.648 14.741 26.129C14.741 26.6102 14.3409 27 13.8475 27C6.19973 27 0 20.9559 0 13.5C0 6.04414 6.19973 0 13.8475 0C21.4953 0 27.695 6.04414 27.695 13.5C27.695 13.981 27.2951 14.371 26.8017 14.371C26.3084 14.371 25.9083 13.981 25.9083 13.5C25.9083 7.00602 20.5088 1.74198 13.8476 1.74198C7.18696 1.74198 1.78692 7.00602 1.78692 13.5C1.78692 19.994 7.18696 25.258 13.8476 25.258L13.8475 25.2581ZM22.3345 23.5162C21.8411 23.5162 21.4413 23.1261 21.4413 22.6451C21.4413 22.1641 21.8412 21.7743 22.3345 21.7743H24.5679C25.0613 21.7743 25.4614 22.1642 25.4614 22.6451C25.4614 23.1262 25.0613 23.5162 24.5679 23.5162H22.3345ZM18.761 13.0648C19.2544 13.0648 19.6545 13.4546 19.6545 13.9356C19.6545 14.4166 19.2544 14.8067 18.761 14.8067H13.4005C12.9071 14.8067 12.5071 14.4166 12.5071 13.9356V6.09694C12.5071 5.61592 12.9072 5.2259 13.4005 5.2259C13.8939 5.2259 14.2938 5.61594 14.2938 6.09694V13.0649L18.761 13.0648Z" fill="#2EC7DE" />
                            </svg>
                          </div>
                          <div>
                            <div className="fw-500 mb-1">Tips for success</div>
                            <div className="text-muted">
                              <ul>
                                {bid.campaignDetail.tips.map(tip => tip && (<li><div className="text-muted">{tip}</div></li>))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                      <div className="bg-white rounded-xl shadow mb-3 mb-md-4">
                        <div className="d-flex align-items-center p-3">
                          <div className="me-3">
                            <svg width="40" height="36" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14 0.422363C10.2869 0.422363 6.72595 1.89611 4.10038 4.51935C1.47497 7.14276 0 10.7008 0 14.4108C0 18.1207 1.47497 21.6788 4.10038 24.3022C6.72595 26.9255 10.287 28.3992 14 28.3992C17.713 28.3992 21.2741 26.9255 23.8996 24.3022C26.525 21.6788 28 18.1207 28 14.4108C28 11.9554 27.3531 9.5432 26.1244 7.41666C24.8957 5.29012 23.1284 3.5243 21.0001 2.29658C18.8718 1.06886 16.4576 0.422523 14.0002 0.422523L14 0.422363ZM14 26.5338C10.7821 26.5338 7.69607 25.2565 5.42037 22.983C3.14498 20.7095 1.86665 17.6259 1.86665 14.4105C1.86665 11.195 3.14498 8.11176 5.42037 5.83793C7.69575 3.56442 10.7819 2.28715 14 2.28715C17.2181 2.28715 20.3039 3.56442 22.5796 5.83793C24.855 8.11144 26.1334 11.195 26.1334 14.4105C26.1334 17.6259 24.855 20.7092 22.5796 22.983C20.3042 25.2565 17.2181 26.5338 14 26.5338Z" fill="#2EC7DE" />
                              <path d="M21.7189 9.15111C21.5439 8.9773 21.3074 8.87988 21.0608 8.87988C20.8143 8.87988 20.5776 8.9773 20.4028 9.15111L11.7325 17.8142C11.6355 17.9054 11.4842 17.9054 11.3871 17.8142L7.59778 14.028C7.42299 13.8544 7.18633 13.7568 6.93987 13.7568C6.69321 13.7568 6.45675 13.8544 6.28174 14.028C6.108 14.2029 6.0105 14.4391 6.0105 14.6856C6.0105 14.9319 6.108 15.1683 6.28174 15.343L11.3871 20.4441C11.4842 20.5353 11.6355 20.5353 11.7325 20.4441L21.7191 10.4936C21.8928 10.3189 21.9903 10.0824 21.9903 9.83619C21.9903 9.58973 21.8928 9.35347 21.7191 9.17861L21.7189 9.15111Z" fill="#2EC7DE" />
                            </svg>
                          </div>
                          <div>
                            <div className="fw-500 mb-1">Complete Submission</div>
                            <div className="text-muted small">Make sure you have completed all the required tasks for this campaign</div>
                            <button type="button" onClick={handleCompleteShow} className="link btn btn-primary mt-3 w-100">
                            {(bid.campaignDetail.campaignType === "content" || bid.campaignDetail.campaignType === "sampling" || (bid.campaignDetail.campaignType === "gifting" && bid.campaignDetail.contentReviewEnabled && !["In Progress", "Ready for Completion"].includes(bid.bidDetail.state)) || bid.bidDetail.state === "Changes Requested") ? "Upload my content" : "Yes, I've done what was asked"}
                            </button>
                          </div>
                        </div>
                        <Link to={`/Inbox?conversation_id=${bid.bidDetail.conversationID}`} className="text-center d-block px-2 py-3 border-top fw-500 text-blue">
                          Message {bid.campaignDetail.brand.name}
                        </Link>
                      </div>
                    </>
                  )}

                  {(bid.bidDetail.state == "Accepted" || bid.bidDetail.state == "In Progress" || bid.bidDetail.state == "Changes Requested" || bid.bidDetail.state == "Ready for Completion") && !dueDate.future && (
                    <>
                      <div className="bg-white rounded-xl shadow mb-3 mb-md-4">
                        <div className="d-flex align-items-center p-3">
                          <div className="me-3">
                            <svg width="40" height="32" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.6059 2.18193C15.6993 2.18193 16.7336 2.92071 17.6497 4.39826L26.1899 20.0307L26.2489 20.1491C26.8104 20.947 27.0172 21.538 27.0172 22.1881C27.0172 23.6952 25.7466 24.8182 24.0916 24.8182H5.14989C3.46537 24.8182 2.22428 23.6952 2.22428 22.1881C2.22428 21.538 2.46072 20.947 2.99256 20.1491L3.05151 20.0307L11.5918 4.39826C12.4785 2.92071 13.5129 2.18193 14.6062 2.18193H14.6059ZM14.6062 1C13.0695 1 11.6806 1.94574 10.5578 3.80729L2.01754 19.4693C1.36742 20.4151 1.04236 21.2425 1.04236 22.188C1.04236 24.3749 2.90413 26 5.14995 26H24.0626C26.3381 26 28.1702 24.4043 28.1702 22.188C28.1702 21.2423 27.8156 20.4149 27.195 19.4693L18.6548 3.80729C17.532 1.94553 16.143 1 14.6063 1C13.0696 1 11.6806 1.94574 10.5578 3.80729L2.01754 19.4693Z" fill="#D70707" />
                              <path d="M13.2467 8.41763C13.2172 8.0334 13.3648 7.67885 13.6309 7.38323C14.1627 6.85142 15.0493 6.85142 15.5813 7.38323C15.8769 7.67883 16.0245 8.09251 15.9655 8.50623V8.59486L15.0789 16.8987C15.0493 17.1648 14.8425 17.3421 14.6061 17.3421C14.3991 17.3421 14.1924 17.1057 14.1629 16.8989L13.2172 8.59507C13.2172 8.53591 13.2172 8.47675 13.2466 8.41759L13.2467 8.41763Z" fill="#D70707" />
                              <path d="M15.9948 19.8225C15.9948 20.5895 15.3729 21.2114 14.6059 21.2114C13.8389 21.2114 13.217 20.5895 13.217 19.8225C13.217 19.0555 13.8389 18.4336 14.6059 18.4336C15.3729 18.4336 15.9948 19.0555 15.9948 19.8225Z" fill="#D70707" />
                            </svg>
                          </div>
                          <div>
                            <div className="fw-500 mb-1">You are {dueDate.difference} {dueDate.unit} overdue</div>
                            <div className="text-muted small">
                              Please ensure that you are creating your campaign content on time as agreed. <br />
                              If you have any issues or concerns, please get in touch with either <strong>{bid.campaignDetail.brand.name}</strong> or <strong>The Influence Room Support</strong> below.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white rounded-xl shadow mb-3 mb-md-4">
                        <div className="d-flex align-items-center p-3">
                          <div className="me-3">
                            <svg width="40" height="36" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14 0.422363C10.2869 0.422363 6.72595 1.89611 4.10038 4.51935C1.47497 7.14276 0 10.7008 0 14.4108C0 18.1207 1.47497 21.6788 4.10038 24.3022C6.72595 26.9255 10.287 28.3992 14 28.3992C17.713 28.3992 21.2741 26.9255 23.8996 24.3022C26.525 21.6788 28 18.1207 28 14.4108C28 11.9554 27.3531 9.5432 26.1244 7.41666C24.8957 5.29012 23.1284 3.5243 21.0001 2.29658C18.8718 1.06886 16.4576 0.422523 14.0002 0.422523L14 0.422363ZM14 26.5338C10.7821 26.5338 7.69607 25.2565 5.42037 22.983C3.14498 20.7095 1.86665 17.6259 1.86665 14.4105C1.86665 11.195 3.14498 8.11176 5.42037 5.83793C7.69575 3.56442 10.7819 2.28715 14 2.28715C17.2181 2.28715 20.3039 3.56442 22.5796 5.83793C24.855 8.11144 26.1334 11.195 26.1334 14.4105C26.1334 17.6259 24.855 20.7092 22.5796 22.983C20.3042 25.2565 17.2181 26.5338 14 26.5338Z" fill="#2EC7DE" />
                              <path d="M21.7189 9.15111C21.5439 8.9773 21.3074 8.87988 21.0608 8.87988C20.8143 8.87988 20.5776 8.9773 20.4028 9.15111L11.7325 17.8142C11.6355 17.9054 11.4842 17.9054 11.3871 17.8142L7.59778 14.028C7.42299 13.8544 7.18633 13.7568 6.93987 13.7568C6.69321 13.7568 6.45675 13.8544 6.28174 14.028C6.108 14.2029 6.0105 14.4391 6.0105 14.6856C6.0105 14.9319 6.108 15.1683 6.28174 15.343L11.3871 20.4441C11.4842 20.5353 11.6355 20.5353 11.7325 20.4441L21.7191 10.4936C21.8928 10.3189 21.9903 10.0824 21.9903 9.83619C21.9903 9.58973 21.8928 9.35347 21.7191 9.17861L21.7189 9.15111Z" fill="#2EC7DE" />
                            </svg>
                          </div>
                          <div>
                            <div className="fw-500 mb-1">Complete Submission</div>
                            <div className="text-muted small">Make sure you have completed all the required tasks for this campaign</div>
                            <button type="button" onClick={handleCompleteShow} className="link btn btn-primary mt-3 w-100">
                            {(bid.campaignDetail.campaignType === "content" || bid.campaignDetail.campaignType === "sampling" || (bid.campaignDetail.campaignType === "gifting" && bid.campaignDetail.contentReviewEnabled && !["In Progress", "Ready for Completion"].includes(bid.bidDetail.state)) || bid.bidDetail.state === "Changes Requested") ? "Upload my content" : "Yes, I've done what was asked"}
                            </button>
                          </div>
                        </div>
                        <Link to={`/Inbox?conversation_id=${bid.bidDetail.conversationID}`} className="text-center d-block px-2 py-3 border-top fw-500 text-blue">
                          Message {bid.campaignDetail.brand.name}
                        </Link>
                      </div>
                    </>
                  )}

                  {bid.bidDetail.state == "Cancelled" && (
                    <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <svg width="40" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 0.875C7.19782 0.875 0.875 7.19782 0.875 15C0.875 22.8022 7.19782 29.125 15 29.125C22.8022 29.125 29.125 22.8022 29.125 15C29.125 7.19782 22.8022 0.875 15 0.875ZM15 27.5419C8.06904 27.5419 2.45814 21.9311 2.45814 15C2.45814 8.06892 8.06892 2.45814 15 2.45814C21.9311 2.45814 27.5419 8.06892 27.5419 15C27.5419 21.9311 21.9311 27.5419 15 27.5419Z" fill="#FF2D55" stroke="#C7C7CC" strokeWidth="0.25" />
                            <path d="M15.0001 13.8898L18.4452 10.4447C18.7596 10.1301 19.2367 10.1291 19.5523 10.4417C19.876 10.7286 19.8661 11.2439 19.555 11.5549L16.1101 14.9998L19.5552 18.4449C19.5552 18.4449 19.5552 18.4449 19.5552 18.4449C19.8708 18.7603 19.8708 19.2394 19.5552 19.5549L19.5552 19.555C19.3991 19.7108 19.2011 19.7915 19.0001 19.7915C18.7991 19.7915 18.6011 19.7108 18.445 19.5547L15.0001 16.1098L11.5552 19.5549L11.5552 19.555C11.3991 19.7108 11.2011 19.7915 11.0001 19.7915C10.7991 19.7915 10.6011 19.7108 10.445 19.5547C10.1294 19.2394 10.1294 18.7602 10.445 18.4447L10.445 18.4447L13.8901 14.9998L10.4452 11.5547L10.4452 11.5547L10.5336 11.4663L15.0001 13.8898ZM15.0001 13.8898L11.5552 10.4447L11.5552 10.4447C11.2397 10.1292 10.7606 10.1291 10.4452 10.4447L15.0001 13.8898Z" fill="#FF2D55" stroke="#C7C7CC" strokeWidth="0.25" />
                          </svg>
                        </div>
                        <div>
                          <div className="fw-500 mb-1">You decided to cancel your bid, no problem</div>
                          <div className="text-muted small">It happens to all of us. You had a change of heart (or perhaps made a mistake when bidding and wanted to have another crack at it). Why not check out what else is on offer?</div>
                        </div>
                      </div>
                    </div>
                  )}

                  {bid.bidDetail.state == "Rejected" && (
                    <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <svg width="40" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 0.875C7.19782 0.875 0.875 7.19782 0.875 15C0.875 22.8022 7.19782 29.125 15 29.125C22.8022 29.125 29.125 22.8022 29.125 15C29.125 7.19782 22.8022 0.875 15 0.875ZM15 27.5419C8.06904 27.5419 2.45814 21.9311 2.45814 15C2.45814 8.06892 8.06892 2.45814 15 2.45814C21.9311 2.45814 27.5419 8.06892 27.5419 15C27.5419 21.9311 21.9311 27.5419 15 27.5419Z" fill="#FF2D55" stroke="#C7C7CC" strokeWidth="0.25" />
                            <path d="M15.0001 13.8898L18.4452 10.4447C18.7596 10.1301 19.2367 10.1291 19.5523 10.4417C19.876 10.7286 19.8661 11.2439 19.555 11.5549L16.1101 14.9998L19.5552 18.4449C19.5552 18.4449 19.5552 18.4449 19.5552 18.4449C19.8708 18.7603 19.8708 19.2394 19.5552 19.5549L19.5552 19.555C19.3991 19.7108 19.2011 19.7915 19.0001 19.7915C18.7991 19.7915 18.6011 19.7108 18.445 19.5547L15.0001 16.1098L11.5552 19.5549L11.5552 19.555C11.3991 19.7108 11.2011 19.7915 11.0001 19.7915C10.7991 19.7915 10.6011 19.7108 10.445 19.5547C10.1294 19.2394 10.1294 18.7602 10.445 18.4447L10.445 18.4447L13.8901 14.9998L10.4452 11.5547L10.4452 11.5547L10.5336 11.4663L15.0001 13.8898ZM15.0001 13.8898L11.5552 10.4447L11.5552 10.4447C11.2397 10.1292 10.7606 10.1291 10.4452 10.4447L15.0001 13.8898Z" fill="#FF2D55" stroke="#C7C7CC" strokeWidth="0.25" />
                          </svg>
                        </div>
                        <div>
                          <div className="fw-500 mb-1">Sorry, it wasn't meant to be this time</div>
                          <div className="text-muted small">Message from {bid.campaignDetail.brand.name}: {bid.bidDetail.reason}</div>
                        </div>
                      </div>
                    </div>
                  )}

                  {bid.bidDetail.state == "Pending" && (
                    <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <svg width="40" height="36" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.7609 22.6451C18.7609 20.7215 20.3607 19.1613 22.3331 19.1613H26.8028C28.7749 19.1613 30.375 20.7233 30.375 22.6451C30.375 24.569 28.7752 26.129 26.8028 26.129H22.3331C20.3611 26.129 18.7609 24.5671 18.7609 22.6451ZM20.5477 22.6451C20.5477 23.6057 21.3485 24.3871 22.3332 24.3871H26.8029C27.7883 24.3871 28.5883 23.6072 28.5883 22.6451C28.5883 21.6848 27.7876 20.9032 26.8029 20.9032H22.3332C21.3477 20.9032 20.5477 21.6833 20.5477 22.6451ZM13.8475 25.2581C14.3409 25.2581 14.741 25.648 14.741 26.129C14.741 26.6102 14.3409 27 13.8475 27C6.19973 27 0 20.9559 0 13.5C0 6.04414 6.19973 0 13.8475 0C21.4953 0 27.695 6.04414 27.695 13.5C27.695 13.981 27.2951 14.371 26.8017 14.371C26.3084 14.371 25.9083 13.981 25.9083 13.5C25.9083 7.00602 20.5088 1.74198 13.8476 1.74198C7.18696 1.74198 1.78692 7.00602 1.78692 13.5C1.78692 19.994 7.18696 25.258 13.8476 25.258L13.8475 25.2581ZM22.3345 23.5162C21.8411 23.5162 21.4413 23.1261 21.4413 22.6451C21.4413 22.1641 21.8412 21.7743 22.3345 21.7743H24.5679C25.0613 21.7743 25.4614 22.1642 25.4614 22.6451C25.4614 23.1262 25.0613 23.5162 24.5679 23.5162H22.3345ZM18.761 13.0648C19.2544 13.0648 19.6545 13.4546 19.6545 13.9356C19.6545 14.4166 19.2544 14.8067 18.761 14.8067H13.4005C12.9071 14.8067 12.5071 14.4166 12.5071 13.9356V6.09694C12.5071 5.61592 12.9072 5.2259 13.4005 5.2259C13.8939 5.2259 14.2938 5.61594 14.2938 6.09694V13.0649L18.761 13.0648Z" fill="#2EC7DE" />
                          </svg>
                        </div>
                        <div>
                          <div className="fw-500 mb-1">Your bid is pending</div>
                          <div className="text-muted small">{bid.campaignDetail.brand.name} will review your bid and be in touch soon!</div>
                        </div>
                      </div>
                    </div>
                  )}

                  {(bid.bidDetail.state == "Marked as Complete" || bid.bidDetail.state == "Completed") && (
                    <div className="bg-white rounded-xl shadow p-3 mb-3 mb-md-4">
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <svg width="40" height="36" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.2841 9.39327L12.0129 16.6191L8.71614 13.3223C8.35485 12.961 7.76776 12.961 7.40647 13.3223C7.04518 13.6836 7.04518 14.2707 7.40647 14.632L11.3807 18.6062C11.5613 18.7868 11.7871 18.8771 12.0581 18.8771C12.2839 18.8771 12.5549 18.7868 12.7355 18.6062L20.6385 10.7032C20.9998 10.3419 20.9998 9.75482 20.6385 9.39353C20.2772 9.03224 19.6449 9.03224 19.2836 9.39353L19.2841 9.39327Z" fill="#34C759" />
                            <path d="M26.5997 10.2516C26.103 10.3419 25.7868 10.8387 25.9223 11.3355C26.103 12.1935 26.1933 13.0968 26.1933 14C26.1933 20.7293 20.7285 26.1935 13.9997 26.1935C7.27097 26.1935 1.80619 20.7288 1.80619 14C1.80619 7.27123 7.27097 1.80645 13.9997 1.80645C15.8062 1.80645 17.5223 2.16774 19.1481 2.93548C19.5997 3.16129 20.1417 2.93548 20.3675 2.48387C20.5933 2.03226 20.3675 1.49032 19.9159 1.26452C18.0643 0.451613 16.0772 0 14 0C6.27768 0 0 6.27716 0 14C0 21.7228 6.27716 28 14 28C21.7228 28 28 21.7228 28 14C28 12.9613 27.9097 11.9226 27.6839 10.929C27.5484 10.4774 27.0968 10.1613 26.6 10.2516H26.5997Z" fill="#34C759" />
                            <path d="M25.0648 5.82534C25.0648 6.32414 24.6603 6.72857 24.1615 6.72857C23.6627 6.72857 23.2583 6.32414 23.2583 5.82534C23.2583 5.32655 23.6627 4.92212 24.1615 4.92212C24.6603 4.92212 25.0648 5.32655 25.0648 5.82534Z" fill="#34C759" />
                          </svg>
                        </div>
                        <div>
                          <div className="fw-500 mb-1">Thanks for collaborating with {bid.campaignDetail.brand.name}</div>
                          {bid.bidDetail.state == "Marked as Complete"
                            ? <div className="text-muted small">They are just checking your content and will confirm whether everything has been completed shortly.</div>
                            : <div className="text-muted small">You've completed this collaboration and now you're ready for more. Why not check out the latest campaigns on offer below?</div>}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="bg-white rounded-xl shadow">
                    <div className="d-flex align-items-center p-3">
                      <div className="me-3">
                        <svg width="40" height="38" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.1035 9.46184C10.9656 9.87536 10.4138 10.082 9.99999 9.94425C9.51718 9.73759 9.31034 9.18628 9.51718 8.77277C10.2758 7.04999 11.931 5.87866 13.8621 5.87866C16.4828 5.87866 18.5517 8.08369 18.5517 10.7022C18.5517 12.6317 17.4482 14.4233 15.7242 15.1813C15.1035 15.4569 14.6896 16.0082 14.6896 16.6973V17.0419C14.6896 17.5243 14.3447 17.9377 13.8621 17.9377C13.3793 17.9377 12.9656 17.5241 12.9656 17.0419V16.6284C12.9656 15.3191 13.7242 14.0787 15.0345 13.5274C16.138 13.045 16.8277 11.9426 16.8277 10.7022C16.8277 9.04849 15.5173 7.67019 13.8622 7.67019C12.6208 7.67019 11.5864 8.35927 11.1036 9.46185L11.1035 9.46184Z" fill="#2EC7DE" />
                          <path fillRule="evenodd" clipRule="evenodd" d="M13.862 19.3848C14.4827 19.3848 15.0345 19.8672 15.0345 20.5562C15.0345 21.1764 14.4827 21.7277 13.862 21.7277C13.1724 21.7277 12.6896 21.1764 12.6896 20.5562C12.6896 19.8672 13.1724 19.3848 13.862 19.3848Z" fill="#2EC7DE" />
                          <path d="M14 0.228027C21.724 0.228027 28 6.49884 28 14.2165C28 21.9341 21.724 28.2049 14 28.2049C6.276 28.2049 0 21.9341 0 14.2165C0 6.49884 6.276 0.228027 14 0.228027ZM14 1.9508C7.2415 1.9508 1.724 7.46324 1.724 14.2167C1.724 20.9701 7.241 26.4825 14 26.4825C20.759 26.4825 26.276 20.9701 26.276 14.2167C26.276 7.46324 20.759 1.9508 14 1.9508Z" fill="#2EC7DE" />
                        </svg>
                      </div>
                      <div>
                        <div className="fw-500 mb-1">Need help?</div>
                        <div className="text-muted small">We are right here to help you with anything. Contact us below.</div>
                      </div>
                    </div>
                    <a onClick={() => this.props.setSupportModal({ "visible": true, "type": "My Bids", "message": "", "context": "influencer" })} className="text-center d-block px-2 py-3 border-top fw-500 text-blue">
                      Contact support
                    </a>
                  </div>
                </div>
              </div>

              {otherCampaigns && otherCampaigns.length > 0 && (
                <div className="col-12 mb-3 mt-md-5 px-md-0">
                  <div className="d-flex justify-content-between align-items-end mb-3 ps-3">
                    <div className="sectionTitle text-truncate">Latest Campaigns</div>
                    <Link to={"/Home"} className="seeAllLink text-nowrap me-3">See all</Link>
                  </div>
                  <div className="multiCarousel px-3 pb-4">
                    {otherCampaigns.map((campaign) =>
                      <this.CampaignItem
                        key={campaign._id}
                        name={campaign.name}
                        images={campaign.images}
                        brandIcon={campaign.brandIcon}
                        id={campaign._id}
                        brandName={campaign.brandName}
                        offering={campaign.offering}
                        class={this}
                      />
                    )}
                  </div>
                </div>
              )}
            </Row>
          </Container>
        </Container>
      );
    }
  }
}

export default function MyBid() {
  let [searchParams] = useSearchParams();
  const [showCancel, setShowCancel] = useState(false);
  const [showComplete, setShowComplete] = useState(false);
  const [supportModal, setSupportModal] = useState({ "visible": false, "type": "My Bids", "message": "", "context": "influencer" });
  const [showAlert, setAlert] = useState({ "display": "toast", "visible": false, "title": "", "content": "" });
  const [cancellationReason, setCancellationReason] = useState("");
  const { providers } = useImageContext();
  const bidID = searchParams.get('id');
  const [images, setImages] = useState([])
  const [links, setLinks] = useState("");
  const [loadingImages, setLoadingImages] = useState(false);
  const [imagesChanged, setImagesChanged] = useState(false);

  return (
    <div className="bg-page bidsView">
      <Topbar />
      <div className="pageName">My Bid</div>
      <SupportModal
        supportModal={supportModal}
        setSupportModal={setSupportModal}
        isInternal={true}
        isPopup={true}
        relatedIDs={[{ "name": "bidID", "value": bidID }]}
      />
      <AlertModal modal={showAlert} onClose={() => setAlert({ "display": "toast", "visible": false, "title": "", "content": "" })} />
      <MyBidView
        bidID={bidID}
        setAlert={setAlert}
        showCancel={showCancel}
        setShowCancel={setShowCancel}
        showComplete={showComplete}
        setShowComplete={setShowComplete}
        providers={providers}
        setSupportModal={setSupportModal}
        images={images}
        setImages={setImages}
        loadingImages={loadingImages}
        setLoadingImages={setLoadingImages}
        imagesChanged={imagesChanged}
        setImagesChanged={setImagesChanged}
        cancellationReason={cancellationReason}
        setCancellationReason={setCancellationReason}
        links={links}
        setLinks={setLinks}
      />
      <Footer />
    </div>
  );
}